/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 监管动态----监管文件
 */
import React from 'react';
import style from './trends.scss';
import { Table } from 'antd';
import messager from '../../../../utils/messager';
import Pagination from '../../../common/pagination/Pagination';
import TableSearch from '../../../common/tableSearch/TableSearch';
import SearchForm from './trends/SearchForm';
import { queryCompanyInfo } from '../../../../services/financialPicture/common';
import { addCollection } from '../../../../services/personalCollect';
import { riskHintTrends } from '../../../../services/regulatoryStatistical';

export default class Trends extends TableSearch {
    constructor(props) {
        super(props);
        this.server = riskHintTrends;
        this.state = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            loading: true,
            data: []
        };
    }

    addCollect = (d) => {
        const {reportDateType, reportType, compcode, reportYear} = d;
        let addParams = {
                companyCode: compcode,
                stockCode: compcode,
                reportYear: reportYear,
                reportDateType,
                reportType
            },
            // 获取收藏结果参数
            companyParams = {
                code: d.compcode,
                date: d.reportYear,
                reportDateType,
                reportType
            };
        addCollection(addParams).then(() => {
            queryCompanyInfo(companyParams).then(data => {
                data = data || {};
                if (data.collect) {
                    messager.success('收藏成功');
                    this.delRefresh();
                } else {
                    messager.error('收藏失败');
                }
            });
        });
    };

    getColumns = () => {
        return [{
            title: '公司简称',
            dataIndex: 'companyName',
            width: 200
        }, {
            title: '发生事项',
            dataIndex: 'item',
            render: text => text.map(d => (<div className={style.renderItem} key={d}>{d}</div>))
        }, {
            title: '事件期间',
            dataIndex: 'reportYear',
            width: 90
        }, {
            title: '操作',
            dataIndex: 'collect',
            width: 100,
            render: (v, d) => <a href="javascript:void(0)" disabled={v} className={v ? 'orange-font' : 'primary-font'} onClick={() => this.addCollect(d)}>
            {v ? '已收藏' : '收藏'}</a>
        }];
    };

    render() {
        const { pageNum, pageSize, total, data, loading } = this.state;
        const { options } = this.props;
        return (
            <div>
                <SearchForm onSearch={this.onSearch} options={options} />

                <Table
                    rowKey="index"
                    className={style.trendsTable}
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={data}
                    bordered
                    footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange} />}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/riskHint/Trends.jsx